document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const panel = document.querySelector('[data-mobile-panel]');

  if (toggle && panel) {
    toggle.addEventListener('click', () => {
      const isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('no-scroll', isOpen);
    });

    panel.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('no-scroll');
      });
    });
  }

  const marketplaceSearch = document.querySelector('[data-agent-search]');
  const cards = Array.from(document.querySelectorAll('[data-agent-card]'));
  const filterButtons = Array.from(document.querySelectorAll('[data-agent-filter]'));
  const emptyState = document.querySelector('[data-agent-empty]');
  let activeDepartment = 'all';

  const filterAgents = () => {
    const query = marketplaceSearch ? marketplaceSearch.value.trim().toLowerCase() : '';
    let visibleCount = 0;

    cards.forEach((card) => {
      const text = card.textContent.toLowerCase();
      const department = card.dataset.department || '';
      const departmentMatch = activeDepartment === 'all' || department === activeDepartment;
      const searchMatch = !query || text.includes(query);
      const isVisible = departmentMatch && searchMatch;
      card.style.display = isVisible ? '' : 'none';
      if (isVisible) visibleCount += 1;
    });

    if (emptyState) emptyState.hidden = visibleCount !== 0;
  };

  if (cards.length) {
    if (marketplaceSearch) marketplaceSearch.addEventListener('input', filterAgents);
    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeDepartment = button.dataset.agentFilter || 'all';
        filterButtons.forEach((btn) => btn.classList.toggle('is-active', btn === button));
        filterAgents();
      });
    });
  }

  const orgList = document.querySelector('[data-org-list]');
  const orgScore = document.querySelector('[data-org-score]');
  const selectedAgents = new Map();
  const departments = ['Executive Office', 'Operations', 'Marketing', 'Sales', 'Technology'];

  const renderOrganization = () => {
    if (!orgList) return;
    const selected = Array.from(selectedAgents.values());
    const covered = new Set(selected.map((agent) => agent.department));
    const score = Math.round((covered.size / departments.length) * 100);

    if (orgScore) orgScore.textContent = String(score);

    departments.forEach((department) => {
      const node = document.querySelector(`[data-coverage="${department}"]`);
      if (node) {
        const hasCoverage = covered.has(department);
        node.textContent = hasCoverage ? 'Covered' : 'Missing';
        node.classList.toggle('is-covered', hasCoverage);
      }
    });

    if (!selected.length) {
      orgList.innerHTML = '<p>No team members selected yet.</p>';
      return;
    }

    orgList.innerHTML = departments.map((department) => {
      const agents = selected.filter((agent) => agent.department === department);
      if (!agents.length) return '';
      return `<div class="ec-org-selected-group"><strong>${department}</strong>${agents.map((agent) => `<span>${agent.icon} ${agent.name}</span>`).join('')}</div>`;
    }).join('');
  };

  document.querySelectorAll('[data-add-agent]').forEach((button) => {
    button.addEventListener('click', () => {
      const agent = {
        name: button.dataset.agent,
        department: button.dataset.department,
        icon: button.dataset.icon || '✓',
      };
      if (!agent.name) return;
      if (selectedAgents.has(agent.name)) {
        selectedAgents.delete(agent.name);
        button.textContent = '+ Add';
        button.classList.remove('is-added');
      } else {
        selectedAgents.set(agent.name, agent);
        button.textContent = '✓ Added';
        button.classList.add('is-added');
      }
      renderOrganization();
    });
  });
});
